/**
 * Formats a member ID string into a specific format based on its length.
 *
 * @param bentoId - The member ID to format.
 * @returns The formatted member ID string, or '-' if the input is invalid or empty.
 */
const formatMemberId = (bentoId: string | null | undefined): string => {
  if (!bentoId) {
    return '-';
  }
  if (bentoId.length === 9) {
    return `B ${bentoId.slice(0, 3)} ${bentoId.slice(3, 6)} ${bentoId.slice(6, 9)}`;
  }
  if (bentoId.length === 10) {
    return `B ${bentoId.slice(1, 4)} ${bentoId.slice(4, 7)} ${bentoId.slice(7, 10)}`;
  }
  return bentoId; // Optionally handle cases for IDs not matching 9 or 10 characters.
};

export default formatMemberId;
